var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('div',{staticClass:"pdf-container"},[(_vm.pdfUrl)?_c('iframe',{ref:"pdfViewer",staticStyle:{"position":"relative"},attrs:{"src":_vm.pdfUrl,"width":"100%","height":"600px"}}):_vm._e()])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }